module.exports = __webpack_public_path__ + "static/img/cinemaPlanLeftFu.08ff795.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cinemaPlanLeftFu.png
// module id = T7py
// module chunks = 2